/* --------------------
smooth scroll
-------------------- */
namespace GundockScroll {
  /**
   * ページ内リンクのスムーススクロールを初期化
   */
  export function initializeSmoothScroll(): void {
    // ページ内リンクを全て取得
    const pageLinks = document.querySelectorAll('a[href^="#"]');

    // 各リンクにイベントリスナーを追加
    pageLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // リンク先の要素IDを取得
        const targetId = link.getAttribute('href');

        // #のみの場合はトップへスクロール
        if (targetId === '#') {
          gsap.to(window, {
            duration: 1,
            scrollTo: 0,
            ease: 'power2.inOut'
          });
          return;
        }

        // ターゲット要素を取得
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          // ターゲット要素へスクロール
          gsap.to(window, {
            duration: 1,
            scrollTo: {
              y: targetElement,
              offsetY: 80 // ヘッダーの高さなどのオフセット
            },
            ease: 'power2.inOut'
          });
        }
      });
    });
  }

  /**
   * スクロールアニメーションの初期化
   */
  export function initializeScrollAnimations(): void {
    // ScrollTriggerプラグインが利用可能か確認
    if (typeof gsap !== 'undefined' && gsap.registerPlugin && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);

      // 予約ボタンのアニメーション設定
      const reservationBtns = document.querySelectorAll('.btn-scr');

      if (reservationBtns.length > 0) {
        // ページ全体のスクロール位置を監視
        ScrollTrigger.create({
          // bodyまたはhtml要素をトリガーとして使用
          trigger: 'body',
          // スクロール開始位置を設定（ページ上部から100px）
          start: "top -100px",
          // 固定位置で常に監視
          endTrigger: 'body',
          end: "bottom top",
          onEnter: () => {
            // 100pxスクロールしたとき
            reservationBtns.forEach(btn => {
              btn.classList.add('active');
            });
          },
          onLeaveBack: () => {
            // 100px未満に戻ったとき
            reservationBtns.forEach(btn => {
              btn.classList.remove('active');
            });
          },
          markers: false // デバッグ時にはtrueにすると便利
        });
      }
    } else {
      console.warn('GSAPまたはScrollTriggerが読み込まれていません');
    }
  }
}

// DOMContentLoadedイベントリスナー
document.addEventListener('DOMContentLoaded', () => {
  GundockScroll.initializeSmoothScroll();
  GundockScroll.initializeScrollAnimations(); // 新しく追加

  // Characters Swiper
  const charactersSwiper = new Swiper('.characters-swiper', {
    spaceBetween: 72,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 'auto',
      },
    },
  });

  // World Swiper
  const worldSwiper = new Swiper('.world-swiper', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.world-swiper .swiper-pagination',
      clickable: true,
    },
    resizeObserver: true,
    updateOnWindowResize: true,
    observer: true,
    observeParents: true,
  });

  // リサイズ処理の最適化
  let resizeTimeout: number | null = null;
  window.addEventListener('resize', () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(() => {
      if (worldSwiper) {
        worldSwiper.update();
      }
    }, 200);
  });
});

/*スクロールバー*/
$(window).on("load", function () {
  $(".scroll-area").mCustomScrollbar({
    scrollbarPosition: "inside",
    axis: "y",
    scrollInertia: 300,
    theme: "light",
    setTop: "0",
    startAt: 0,
    autoDraggerLength: true,
    callbacks: {
      onCreate: function () {
        // コンテナ要素を取得して強制的にトップ位置に設定
        const container = $(this).find(".mCSB_container");
        container.css("top", "0px");
      },
      onInit: function () {
        // 初期化後に強制的にスクロール位置をリセット
        $(this).mCustomScrollbar("scrollTo", "top", {
          scrollInertia: 0
        });
      },
      whileScrolling: function () {
        // スクロール中にコンテナの位置をチェック
        const container = $(this).find(".mCSB_container");
        const dragger = $(this).find(".mCSB_dragger");

        // ドラッガーが最上部にある場合はコンテナも最上部に
        if (dragger.position().top === 0 && parseInt(container.css("top")) < 0) {
          container.css("top", "0px");
        }
      }
    },
    advanced: {
      updateOnContentResize: true,
      autoExpandHorizontalScroll: false
    }
  });

  // 初期化後に少し遅延させて再度スクロール位置をリセット
  setTimeout(function () {
    const scrollArea = $(".scroll-area");
    const container = scrollArea.find(".mCSB_container");

    // コンテナ位置を強制的にリセット
    container.css("top", "0px");

    // スクロール位置も明示的にリセット
    scrollArea.mCustomScrollbar("scrollTo", "top", {
      scrollInertia: 0
    });
  }, 200);

  //ニュースがn個以上の場合はoverflowを付ける
  const newsItems = document.querySelectorAll('.scroll-body ul li');
  if (newsItems.length >= 3) {
    const newsBody = document.querySelector('.scroll-body');
    newsBody.classList.add('overflow');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('holobook-video') as HTMLVideoElement;

  if (video) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(error => {
              console.error('Video play failed:', error);
            });
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5, // 要素が50%表示されたらコールバックを実行
      }
    );

    observer.observe(video);
  }
});